import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ROLE } from '../Services/auth.service';
import { Loading } from '../components/Loading';
import { UserContext } from '../context/userContext';

export const PrivateRoute = ({ roles, children }) => {
  const location = useLocation();
  const { user, isLoading } = useContext(UserContext);

  if (isLoading) return <Loading />;

  if (!user) return <Navigate to={'/login'} state={{ from: location }} replace />;

  if (user.role === ROLE.Root || roles.includes(user.role)) {
    return <>{children}</>;
  }

  return <Navigate to={'/401'} state={{ from: location }} replace />;
};
